import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const GlobalAdminAIPartnersListViewParent = styled.div ``;
export const PartnersTable = styled.table `
    font-size: ${fontSizes.SMALL};
    margin-top: 5px;
    width: 100%;
    border: 2px solid ${colors.black_30};
    border-collapse: collapse;
    & th {
        text-align: left;
    }

    & th,
    td {
        padding: 8px 10px;
        vertical-align: middle;
    }

    & tbody tr:nth-child(odd) {
        background-color: ${colors.black_4};
    }
`;
export const ActionTableCell = styled.td `
    width: 200px;
    text-align: right;

    & > * {
        padding-right: 8px;
    }
    & > *:last-child {
        padding-right: 0;
    }
`;
export const StatusBadge = styled.span `
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    background-color: ${({ active }) => (active ? "#e8f5e9" : "#ffebee")};
    color: ${({ active }) => (active ? "#2e7d32" : "#c62828")};
`;
export const IpList = styled.span `
    font-family: monospace;
    font-size: 12px;
    color: ${colors.black_30};
`;
